<template>
    <div>
		<v-dialog>
			<v-card>
				<!-- Edit  -->
			</v-card>
		</v-dialog>
        <v-row>
            <v-col cols="2">
                <v-text-field label="Name" />
            </v-col>

            <v-col>
				<bee-date-input v-model="myDate" append-icon="mdi-menu-right" @click:append="myDateUp()" prepend-icon="mdi-menu-left" @click:prepend="myDateDown()" label="Work day" date-tooltip></bee-date-input>
            </v-col>

            <v-col>
                <v-text-field label="Enter Time" />
            </v-col>

            <v-col>
                <v-text-field label="Leave Time" />
            </v-col>

            <v-col>
                <v-text-field label="Tasks" />
            </v-col>
        </v-row>
		<bee-handy-smart-table
			:headers="headers"
			v-model="tableInputs"
			:items="entries"
			:items-per-page="-1"
			:loading="loading"
			:data-table-props="{
				disableSort: true,
				noDataText: ''
			}"
			fixed-header
			hide-default-footer
			dense
			show-add-row
			:editable-rows="!loading"
			height="auto"
			:context-menu-items="contextMenuItems"
			stay-in-input-fields
			:reset-inputs-focus.sync="resetInputsFocus"
			:reset-edit.sync="resetEdit"
			hide-inputs-details
			@edit-cancelled="isEditItem = false"
			@context-menu-edit="setRowIndex"
			@context-menu-delete="deleteItem"
			@keypress.enter="!isEditItem ? addItem() : editItem()"
			@reached-last-input="!isEditItem ? addItem() : editItem()"
			zebra
			table-class="py-2 px-3"
			:disable-context-menu="loading"
			:disable-input-fields="loading"
		>
		</bee-handy-smart-table>
        <div class="my-2">
            <span class="mx-4">Total Duration: 2 h 3 m </span>
            <span class="mx-4">Actual Duration: 3 h 2 m</span>
            <span class="mx-4">Lost Time: 4:07 pm</span>
            <span class="mx-4">Metting: 0 h 0 m</span>
            <span class="mx-4">Variance: 0 h 0 m </span>
        </div>
        <!-- </v-row> -->
    </div>
</template>

<script>
/*
	resetInputs
	validate
*/
import moment from 'moment'
export default {
	data () {
		return {
			tableInputs: {},
			rowEditIndex: null,
			loading: false,
			resetInputsFocus: false,
			resetEdit: false,
			isEditItem: false,
			headers: [
				{ text: '#', name: 'no', value: 'no' },
				{ text: 'Project', name: 'project', value: 'project' },
				{ text: 'Task content', name: 'taskContent', value: 'taskContent' },
				{ text: 'Time spent', name: 'time', value: 'time' },
				{ text: 'Tags', name: 'tags', value: 'tags' }
			],
			entries: [
				{
					no: 18765,
					project: 'Edunix',
					taskContent: 'Lorem ipsum dolor sit amet consectetur adipisici',
					time: '2:00 h '
				},
				{
					no: 18765,
					project: 'Edunix',
					taskContent: 'Lorem ipsum dolor sit amet consectetur adipisici',
					time: '2:00 h '
				},
				{
					no: 18765,
					project: 'Edunix',
					taskContent: 'Lorem ipsum dolor sit amet consectetur adipisici',
					time: '2:00 h '
				},
				{
					no: 18765,
					project: 'Edunix',
					taskContent: 'Lorem ipsum dolor sit amet consectetur adipisici',
					time: '2:00 h '
				},
				{
					no: 18765,
					project: 'Edunix',
					taskContent: 'Lorem ipsum dolor sit amet consectetur adipisici',
					time: '2:00 h '
				}
			],
			myDate: ''
		}
	},
	watch: {
	},
	computed: {
		contextMenuItems () {
			return [
				{ title: 'Edit', icon: 'mdi-pencil', iconColor: 'edit-color', event: 'edit', class: 'edit-color--text' },
				{ title: 'Delete', icon: 'mdi-delete', iconColor: 'alert-color', event: 'delete', class: 'alert-color--text' }
			]
		},
		watchFields () {
			return `${this.tableInputs.project}`
		}
	},
	methods: {
		moment,
		myDateUp () {
			this.myDate = this.moment(this.myDate).add(1, 'day').format('YYYY-MM-DD')
			return this.myDate
		},
		myDateDown () {
			this.myDate = this.moment(this.myDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.myDate
		},
		setRowIndex (rowData) {
			this.rowEditIndex = rowData.index
			this.isEditItem = true
		},
		deleteItem ({ index }) {
			this.resetEdit = true
			this.isEditItem = false
			this.entries.splice(index, 1)
		},
		editItem () {
			this.entries[this.rowEditIndex].project = this.tableInputs.project
			this.resetEdit = true
			this.resetTableInputs()
			this.isEditItem = false
			this.resetInputsFocus = true
		},

		addItem () {
			// if (!this.validationMessages.length) {
			const itemInTable = this.entries.find(c => c.itemId === this.tableInputs.itemId)
			if (!itemInTable) {
				const no = this.entries.length
				this.entries.push({
					no: no,
					quantity: this.quantityEntreyDialog,
					barcode: this.getItemById(this.tableInputs.itemId).barcode,
					...this.tableInputs
				})
			} else {
				itemInTable.quantity = Number(itemInTable.quantity) + Number(this.tableInputs.quantity)
				itemInTable.amount = itemInTable.quantity * itemInTable.price
				itemInTable.discount = itemInTable.amount * ((itemInTable.percentDiscount || 0) / 100)
				itemInTable.totalNet = itemInTable.amount - itemInTable.discount
			}

			this.$nextTick(() => {
				this.resetTableInputs()
				this.resetInputsFocus = true
			})
			// }
		}
	}

}
</script>
